<div class="payroll-page">

  <div class="page-header">

    <div>

      <div class="breadcrumb">
        HR Management / Payroll
      </div>

      <h1>
        Payroll
      </h1>

      <p>
        Manage employee salaries and payroll processing.
      </p>

    </div>

    <button
      mat-raised-button
      color="primary"
      (click)="refresh()">

      <mat-icon>
        refresh
      </mat-icon>

      Refresh

    </button>

  </div>


  <div class="stats-grid">

    <mat-card class="stat-card">
      <div class="stat-icon primary">
        <mat-icon>payments</mat-icon>
      </div>
      <div class="stat-info">

        <span>Total Payroll</span>

        <strong>₨{{ totalPayroll | number:'1.0-0' }}</strong>

      </div>
    </mat-card>

    <mat-card class="stat-card">
      <div class="stat-icon success">
        <mat-icon>people</mat-icon>
      </div>
      <div class="stat-info">

        <span>Employees</span>

        <strong>{{ records.length }}</strong>

      </div>
    </mat-card>

    <mat-card class="stat-card">
      <div class="stat-icon warning">
        <mat-icon>pending_actions</mat-icon>
      </div>
      <div class="stat-info">

        <span>Pending</span>

        <strong>{{ getPendingCount() }}</strong>

      </div>
    </mat-card>

    <mat-card class="stat-card">
      <div class="stat-icon purple">
        <mat-icon>check_circle</mat-icon>
      </div>
      <div class="stat-info">

        <span>Processed</span>

        <strong>{{ getProcessedCount() }}</strong>

      </div>
    </mat-card>

  </div>


  <mat-card class="payroll-card">

    <div class="card-header">

      <div>

        <h2>
          Payroll Records
        </h2>

        <p>
          Current month salary breakdown
        </p>

      </div>

    </div>

    <mat-divider></mat-divider>

    <div class="loading-container" *ngIf="loading">

      <mat-spinner diameter="45">
      </mat-spinner>

    </div>

    <div class="table-container" *ngIf="!loading">

      <table
        mat-table
        [dataSource]="filteredRecords"
        class="payroll-table">

        <ng-container matColumnDef="employee">
          <th mat-header-cell *matHeaderCellDef>
            Employee
          </th>
          <td mat-cell *matCellDef="let record">
            {{ record.employeeName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="department">
          <th mat-header-cell *matHeaderCellDef>
            Department
          </th>
          <td mat-cell *matCellDef="let record">
            {{ record.department }}
          </td>
        </ng-container>

        <ng-container matColumnDef="basic">
          <th mat-header-cell *matHeaderCellDef>
            Basic Salary
          </th>
          <td mat-cell *matCellDef="let record">
            ₨{{ record.basicSalary | number:'1.0-0' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="allowances">
          <th mat-header-cell *matHeaderCellDef>
            Allowances
          </th>
          <td mat-cell *matCellDef="let record">
            ₨{{ record.allowances | number:'1.0-0' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="deductions">
          <th mat-header-cell *matHeaderCellDef>
            Deductions
          </th>
          <td mat-cell *matCellDef="let record">
            ₨{{ record.deductions | number:'1.0-0' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="net">
          <th mat-header-cell *matHeaderCellDef>
            Net Salary
          </th>
          <td mat-cell *matCellDef="let record">
            <strong>₨{{ record.netSalary | number:'1.0-0' }}</strong>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            Status
          </th>
          <td mat-cell *matCellDef="let record">
            <span
              class="status-badge"
              [class.processed]="record.status === 'Processed'"
              [class.pending]="record.status === 'Pending'">

              {{ record.status }}

            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

    </div>

  </mat-card>

</div>
